<div class="more-like-this">
    <h4>{{ title }}</h4>
    <finder-button *ngFor="let link of links"
        href="{{ entityTypeUrl + link.urlFriendlyId }}"
        [theme]="'tertiary'"
        [fitText]="true">
        {{ link.value }}
    </finder-button>
</div>